import type {
  BobToastColor,
  BobToastOptions,
  BobToastPosition,
} from "./bob-toast.types";

export const BOB_TOAST_DEFAULTS: Required<
  Pick<
    BobToastOptions,
    "position" | "duration" | "color" | "replaceCurrent" | "showClose"
  >
> = {
  position: "bottom",
  duration: 3000,
  color: "medium",
  replaceCurrent: true,
  showClose: true,
};

export const BOB_TOAST_DEFAULT_ICONS: Record<BobToastColor, string> = {
  warning: "warning-outline",
  danger: "close-circle-outline",
  medium: "information-circle-outline",
  success: "checkmark-circle-outline",
};

export function resolveBobToastPosition(
  position?: BobToastPosition,
  allowTop = false
): BobToastPosition {
  const resolved = position ?? BOB_TOAST_DEFAULTS.position;
  if (allowTop && resolved === "top") {
    return "top";
  }
  return "bottom";
}

export function resolveBobToastIcon(
  color: BobToastColor,
  icon?: string
): string {
  return icon ?? BOB_TOAST_DEFAULT_ICONS[color];
}
